'use strict';

const StageEnv = {
  Local: "local",
  Dev: "dev",
  QA: "qa",
  Prod: "prod"
};

exports.StageEnv = StageEnv;
//# sourceMappingURL=stage.cjs.map
